/* eslint-disable */
// src/services/authService.js

import axios from "services/axiosConfig";

export default class AuthService {
  static async logout() {
    return axios.post("/refresh/logout");
  }
}
